import { createOptimizelyInstance, type Client } from '@sbt-web/optimizely-sdk';
import { ENV } from '@sbt-web/utils';

let optimizely: Promise<Client | null> | null = null;

/**
 * Lazily creates the Optimizely SDK client and guarantees that
 * every concurrent caller awaits the same initialisation flow.
 */
export function getSSROptimizelyClient(): Promise<Client | null> {
  if (!optimizely) {
    optimizely = (async () => {
      const instance = createOptimizelyInstance(
        process.env.NEXT_PUBLIC_INTERNAL_ENVIRONMENT as ENV
      );

      if (!instance?.onReady) {
        return null;
      }

      // Wait for datafile & flags before exposing the instance
      await instance.onReady?.({
        timeout: Number.parseInt(process.env.HOUSTON_SERVER_TIMEOUT_MS, 10),
      });

      return instance;
    })();
  }

  return optimizely;
}
